import { useTypedSelector } from "store/reducers/use-typed-selector";
import { selectAttendeeInPersonEnabled } from "store/selectors/live-event";

import './in-person-attendee-message.scss';
import { useTranslate } from "i18n/useTranslationModules";
import classnames from "classnames";

interface IInPersonAttendeeMessageProps {
	className?: string;
}

const InPersonAttendeeMessage = ({ className }: IInPersonAttendeeMessageProps) => {
	const { t } = useTranslate("session");

	const attendeeInPersonEnabled = useTypedSelector(selectAttendeeInPersonEnabled);

	if (!attendeeInPersonEnabled) return null;
	return (
		<div className={classnames("in-person-message-container", className)}>
			<h4>{t("session:Video is off for in-person mode. To watch the stream here, turn off in-person view in your profile menu.", "Video is off for in-person mode. To watch the stream here, turn off in-person view in your profile menu.")}</h4>
		</div>
	);
};

export default InPersonAttendeeMessage;
